import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserSettingsRoutingModule } from './user-settings-routing.module';
import { UserSettingsFormComponent } from './user-settings-form/user-settings-form.component';
import { SharedModule } from '../shared/shared.module';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { SharedFormSectionsModule } from '../shared-form-sections/shared-form-sections.module';
import { AutoCompleteComponent } from '../shared-form-sections/components/auto-complete/auto-complete.component';

@NgModule({
  declarations: [UserSettingsFormComponent],
  imports: [
    CommonModule,
    SharedModule,
    SharedFormSectionsModule,
    UserSettingsRoutingModule,
    MatInputModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    AutoCompleteComponent,
  ],
})
export class UserSettingsModule {}
